import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/atoms";
import buildClassName from "src/utils/buildClassName";
import { Icon } from "src/components/atoms";

const WrapperDivHGash = styled.div`
  height: 0;
  overflow: hidden;
  display: flex;
  flex-flow: row wrap;
  width: 120px;
  min-height: 1px;
  position: absolute;
  top: 42px;
  background-color: ${(props) => props.theme.bgColor2};
  transition: height 0.3s ease;
  &.active {
    z-index: 5;
    overflow: visible;
    height: 80px;
  }
`;

const LanguageOptions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 50%;
  cursor: pointer;
  color: grey;
`;

const LanguageSwitchButton: React.FC = () => {
  const { i18n } = useTranslation();
  const lng = i18n.language;
  const [show, setShow] = useState(false);
  const overlayRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        overlayRef.current &&
        !overlayRef.current.contains(event.target as Node)
      ) {
        setShow(false);
      }
    };
    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("i18nextLng");
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
      document.documentElement.setAttribute(
        "dir",
        savedLanguage === "fa" ? "rtl" : "ltr"
      );
    }
  }, [i18n]);

  const changeLanguage = () => {
    const newLanguage = i18n.language === "en" ? "fa" : "en";
    const savedLanguage = localStorage.getItem("i18nextLng");

    i18n.changeLanguage(newLanguage);
    localStorage.setItem("i18nextLng", newLanguage);
    document.documentElement.setAttribute(
      "dir",
      newLanguage === "fa" ? "rtl" : "ltr"
    );
    window.location.reload();
  };

  return (
    <div>
      <Icon
        name={"languageBtn"}
        width={"25px"}
        height={"25px"}
        onClick={() => setShow(!show)}
        style={{ position: "relative", marginInlineEnd: "10px", cursor: "pointer" }}
      />
      {show && (
        <WrapperDivHGash
          ref={overlayRef}
          onClick={(e) => e.stopPropagation()}
          className={show ? buildClassName("active") : ""}
        >
          <LanguageOptions onClick={lng === "en" ? changeLanguage : undefined}>
            فارسی
            <Icon name={"iranFlag"} width={"20px"} height={"20px"} />
          </LanguageOptions>
          <LanguageOptions onClick={lng === "fa" ? changeLanguage : undefined}>
            English
            <Icon name={"ukFlag"} width={"20px"} height={"20px"} />
          </LanguageOptions>
        </WrapperDivHGash>
      )}
    </div>
  );
};

export default LanguageSwitchButton;
